import {gql} from '@apollo/client';

export const GQL_ICONS = gql`
  query {
    icons_gql {
      ok
      message
      data {
        id
        title
        icon_svgs
        icon_paths
        num_paths
        icon_circle
        icon_polygon
        icon_ellipses
        icon_without_fill
      }
    }
  }
`;

